import { API } from '@/shared/api/modules';
import type { GetOccupancyLosScatterRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getOccupancyLosScatterQueryOptions = (
  params: GetOccupancyLosScatterRequestDto
) =>
  queryOptions({
    queryKey: ['occupancy-los-scatter', params],
    queryFn: async ({ signal }) => {
      return await API.facilities.getOccupancyLosScatter(params, {
        signal,
      });
    },
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
